var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTopicsSlim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 76,
    viewBox: "0 0 80 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 2.25,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 2.75,
    width: 43.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 12.75,
    width: 18.5,
    height: 4.5,
    rx: 1.25,
    fill: "#C8D0E5",
    fillOpacity: 0.1,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 28.75,
    width: 18.5,
    height: 18.5,
    rx: 2.25,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 31,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#C8D0E5",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 30.75,
    width: 53.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 40.75,
    width: 33.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 56.75,
    width: 18.5,
    height: 18.5,
    rx: 2.25,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 58.75,
    width: 48.5,
    height: 4.5,
    rx: 1.25,
    fill: "#C8D0E5",
    fillOpacity: 0.1,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 68.75,
    width: 38.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#C8D0E5",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTopicsSlim);
export default __webpack_public_path__ + "static/media/noTopicsSlim.819ef223ed4d6d330c8ce09dee908750.svg";
export { ForwardRef as ReactComponent };